import React from "react";
import TextField from "../../../bootstrap/TextField";
import { Passenger, Select } from "./singleTravellerInformation.styles";

const SingleTravellerInformation = ({
  values = {},
  passengerIndex,
  handleChange,
  seatNumber,
  contactPhone = "",
  contactEmail = "",
}) => {
  const index = passengerIndex;
  const useContact = values[`useContact${index}`] !== false;

  return (
    <div className="passenger-details-card">
      <Passenger>
        <div className="passenger-card-heading">
          <strong>Passenger {index}</strong>
          {seatNumber && <span>Seat {seatNumber}</span>}
        </div>

        <div className="passenger-fields-grid">
          <label>
            First name <span>*</span>
            <TextField
              name={`first${index}`}
              placeholder="First name"
              value={values[`first${index}`] || ""}
              onChange={handleChange}
              autoComplete="given-name"
            />
          </label>

          <label>
            Last name <span>*</span>
            <TextField
              name={`second${index}`}
              placeholder="Last name"
              value={values[`second${index}`] || ""}
              onChange={handleChange}
              autoComplete="family-name"
            />
          </label>

          <label>
            ID / passport number <span>*</span>
            <TextField
              name={`renid${index}`}
              placeholder="Document number"
              value={values[`renid${index}`] || ""}
              onChange={handleChange}
            />
          </label>

          <label>
            Nationality <span>*</span>
            <Select
              name={`nationality${index}`}
              value={values[`nationality${index}`] || "Kenya"}
              onChange={handleChange}
            >
              <option value="Kenya">Kenya</option>
              <option value="Uganda">Uganda</option>
              <option value="Tanzania">Tanzania</option>
              <option value="Rwanda">Rwanda</option>
              <option value="South Sudan">South Sudan</option>
              <option value="Other">Other</option>
            </Select>
          </label>
        </div>

        <label className="passenger-contact-choice">
          <input
            type="checkbox"
            name={`useContact${index}`}
            checked={useContact}
            onChange={(event) =>
              handleChange({
                target: {
                  name: `useContact${index}`,
                  value: event.target.checked,
                },
              })
            }
          />
          Use booking contact details for this passenger
        </label>

        {useContact && (
          <div className="passenger-contact-preview">
            {contactPhone && <span>{contactPhone}</span>}
            {contactEmail && <span>{contactEmail}</span>}
          </div>
        )}

        {!useContact && (
          <div className="passenger-fields-grid">
            <label>
              Passenger phone
              <TextField
                name={`contactNo${index}`}
                type="tel"
                placeholder="Phone number"
                value={values[`contactNo${index}`] || ""}
                onChange={handleChange}
              />
            </label>
            <label>
              Passenger email
              <TextField
                name={`passengerEmail${index}`}
                type="email"
                placeholder="Email address"
                value={values[`passengerEmail${index}`] || ""}
                onChange={handleChange}
              />
            </label>
          </div>
        )}
      </Passenger>
    </div>
  );
};

export default SingleTravellerInformation;